/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignRawMetricRequest
 */
export interface AssignRawMetricRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignRawMetricRequest
     */
    key?: string;
}

/**
 * Check if a given object implements the AssignRawMetricRequest interface.
 */
export function instanceOfAssignRawMetricRequest(value: object): value is AssignRawMetricRequest {
    return true;
}

export function AssignRawMetricRequestFromJSON(json: any): AssignRawMetricRequest {
    return AssignRawMetricRequestFromJSONTyped(json, false);
}

export function AssignRawMetricRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignRawMetricRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
    };
}

export function AssignRawMetricRequestToJSON(json: any): AssignRawMetricRequest {
    return AssignRawMetricRequestToJSONTyped(json, false);
}

export function AssignRawMetricRequestToJSONTyped(value?: AssignRawMetricRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
    };
}

